import Vue from 'vue';

export default {
    state: {},
    mutations: {},
    getters: {},
    actions: {
        async uploadImage({},data) {
            const response = await Vue.http.post('ayuda/imagen', {
                imagen: data.imageBase64,
                cia: data.cia && data.cia.nomcia ? data.cia.nomcia : 'general'
            });

            if (!response.body || !response.body.res || (!response.body.url && !response.body.url_absoluta)) {
                throw new Error(response.body && response.body.message ? response.body.message : 'No fue posible subir la imagen');
            }

            if (response.body.url_absoluta) {
                return response.body.url_absoluta;
            }

            if (response.body.url && response.body.url.indexOf('http') === 0) {
                return response.body.url;
            }

            return window.location.origin + response.body.url;
        },
    }
}



// WEBPACK FOOTER //
// ./src/modules/editor.js